// extracted by mini-css-extract-plugin
module.exports = {"cardGrid":"src-components-UI-CardGrid-Grid-styles-style-module__cardGrid--2A-kQ"};